// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4564":"a1c42139","4913":"e1316be7"}[chunkId] + ".chunk.css";
};